import { TYPE_STANDARD, TYPE_RADIOMETRO, TYPE_DMA } from 'components/Geofence/constant';

const KEYS = [
    "name",
    "ads",
    "visits",
    "new_users",
    "visitad"
    
];

const HEADER_GEO_FENCING = [
    "Location",
    "Ads",
    "Ads Visits",
    "New Ad Users",
    "Visits/Ad"
];

export const HEADER_TYPE = {
    [TYPE_STANDARD]: "Ad Visits by Location",
    [TYPE_RADIOMETRO]: "Ad Visits by Metro",
    [TYPE_DMA]: "Ad Visits by DMA"
};

export const HEADER_TITLE = "Location";
export const HEADER_CHART_FILE_NAME = "location_chart";
export const TABLE_FILE_NAME = "location_table";

export const UNIDENTIFINEDLOCATION = ['ZZ', '0'];
export const GEO_TABLE_TITLE = {
    [TYPE_RADIOMETRO]: 'Metro',
    [TYPE_DMA]: 'DMA',
    [TYPE_STANDARD]: 'Location'
  };

export default {
    HEADER_GEO_FENCING,
    KEYS
};
